import { render, staticRenderFns } from "./viaspago-form.vue?vue&type=template&id=6b9ec44a&scoped=true"
import script from "./viaspago-form.vue?vue&type=script&lang=js"
export * from "./viaspago-form.vue?vue&type=script&lang=js"
import style0 from "./viaspago-form.vue?vue&type=style&index=0&id=6b9ec44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9ec44a",
  null
  
)

export default component.exports